import React from 'react';

const NotFound = ({ location }) => {
  return (
    <div>
      Not Found
      <br />
      Path name: {location.pathname}
    </div>
  );
};
export { NotFound };
